// Page numbers to show around the current page, e.g. (5, 10) → [3, 4, 5, 6, 7].
export default function pageWindow(current, totalPages, size = 5) {
  const half = Math.floor(size / 2);
  let start = Math.max(1, current - half);
  const end = Math.min(totalPages, start + size - 1);
  start = Math.max(1, end - size + 1);
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
